var map = {
	"./cl.svg": 14644,
	"./close.svg": 98179,
	"./jy.svg": 53762,
	"./language.svg": 5247,
	"./location.svg": 80676,
	"./minus.svg": 93331,
	"./plane.svg": 13097,
	"./plus.svg": 39637,
	"./setting.svg": 62419,
	"./signal.svg": 22353,
	"./sj.svg": 29434,
	"./standard.svg": 68638,
	"./strong.svg": 69740,
	"./unLine.svg": 2690,
	"./warn.svg": 74145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;